module.exports = __webpack_public_path__ + "img/bg_us.4421d412.png";